

export enum MeetingRole {
    ORGANIZER       = 1,
    PARTICIPANT     = 3

}

export enum MeetingNoteAccess {
    PRIVATE       = 1,
    PUBLIC     = 2

}

